import {
  setCheckButtons,
  setTableButtons,
  setFormButtons
} from '@/utils/getbuttons.js'
import { clone } from '@/utils/handleData'
import goodsShipmentPages from '@/utils/pageParams/goodsShipment'

const componentTypes = [
      'navigate',
  'pageTabs',
      'check',
      'tables',
      'drawerTable',
      'dialogForm'
]

// 复用物料运输新增表单配置，挂在拌合站主题下，返回本模块列表
const goodsShipment = Object.assign({}, clone(goodsShipmentPages.goodsShipment), {
  componentTypes: ['navigate', 'stepForm', 'dialogForm'],
  getParentFun: 'mixingProduction/getMixingProductionList',
  getListFun: 'mixingProduction/getMixingProductionList'
})
// 生产模块内编辑：锁定已关联的运输类型/业务单/生产单；新增时可改挂同标号待生产
;(function lockRelationFields(page) {
  const fields = page.formData && page.formData.fields
  if (!fields) return
  fields.forEach((field) => {
    const key = typeof field.key === 'function' ? null : field.key
    const isRelation =
      key === 'shipmentType' ||
      key === 'workUid' ||
      key === 'productionTaskUid' ||
      (typeof field.key === 'function' &&
        (field.label === '业务单信息' || field.label === '生产单信息'))
    if (
      !isRelation &&
      field.label !== '运输类型描述' &&
      field.label !== '业务单信息' &&
      field.label !== '生产单信息'
    ) {
      return
    }
    if (
      field.label === '运输类型描述' ||
      field.label === '业务单信息' ||
      field.label === '生产单信息'
    ) {
      const prev = field.disabled
      field.disabled = (params) => {
        if (params.pageStatus !== 'add') return true
        // 砼拌站「运输装车」入口：运输类型固定混凝土运输
        if (
          field.label === '运输类型描述' &&
          params.formValues &&
          params.formValues.sourceProductionTaskUid
        ) {
          return true
        }
        return typeof prev === 'function' ? prev(params) : !!prev
      }
    }
    if (field.label === '业务单信息') {
      field.options = (params) => {
        const form = params.formValues || {}
        const current = form.workUid
        const targets =
          (params.state.mixingProduction &&
            params.state.mixingProduction.shipmentLoadTargets) ||
          []
        if (form.sourceProductionTaskUid && targets.length) {
          const seen = {}
          const options = []
          targets.forEach((item) => {
            if (!item.orderUid || seen[item.orderUid]) return
            seen[item.orderUid] = true
            options.push({
              value: item.orderUid,
              label:
                (item.pouringOrderCode || '-') +
                ' ' +
                (item.pouringLocation || item.subitemName || '-') +
                ' ' +
                (item.strengthGrade || '') +
                (item.taskStatus === '1' ? '（当前）' : '（待生产）')
            })
          })
          return options
        }
        const list = (params.getters.workList || []).slice()
        if (
          current &&
          !list.some((item) => item && item.value === current)
        ) {
          const order = form.orderInfo || {}
          list.unshift({
            value: current,
            label:
              order.pouringOrderCode ||
              form.workInfo ||
              form.workName ||
              current
          })
        }
        return list
      }
      const prevDisabled = field.disabled
      field.disabled = (params) => {
        if (params.pageStatus !== 'add') return true
        const form = params.formValues || {}
        if (form._pendingLoadBlocked || form._lockRelation) return true
        return typeof prevDisabled === 'function'
          ? prevDisabled(params)
          : !!prevDisabled
      }
      field.placeholder = '请选择同标号待生产队列对应浇筑令'
    }
    if (field.label === '生产单信息') {
      field.options = (params) => {
        const form = params.formValues || {}
        const current = form.productionTaskUid
        const targets =
          (params.state.mixingProduction &&
            params.state.mixingProduction.shipmentLoadTargets) ||
          []
        if (form.sourceProductionTaskUid && targets.length) {
          return targets
            .filter((item) => item.orderUid === form.workUid)
            .map((item) => {
              const loadable =
                item.taskStatus === '1'
                  ? item.currentBatchQuantity
                  : item.remainQuantity
              const qty =
                loadable != null && loadable !== ''
                  ? Number(loadable)
                  : null
              const pendingTag = item.hasPendingLoad ? '【待装车】' : ''
              const qtyText =
                qty != null && !isNaN(qty) ? ' 可装' + qty + 'm³' : ''
              return {
                value: item.uid,
                label: (item.label || item.taskCode || '') + qtyText + pendingTag,
                hasPendingLoad: item.hasPendingLoad,
                currentBatchQuantity: item.currentBatchQuantity,
                remainQuantity: item.remainQuantity
              }
            })
        }
        const raw =
          (params.state.mixingProduction &&
            params.state.mixingProduction.orderTaskOptions) ||
          []
        const list = raw.map((item) => {
          if (!item) return item
          const loadable =
            item.taskStatus === '1' || item.taskStatus === 1
              ? item.currentBatchQuantity
              : item.remainQuantity
          const qty =
            loadable != null && loadable !== '' ? Number(loadable) : null
          const pendingTag = item.hasPendingLoad ? '【待装车】' : ''
          const base = item.label || item.taskCode || item.value || ''
          const hasQty = String(base).indexOf('可装') >= 0
          const qtyText =
            !hasQty && qty != null && !isNaN(qty) ? ' 可装' + qty + 'm³' : ''
          return Object.assign({}, item, {
            value: item.value || item.uid,
            label: base + qtyText + pendingTag
          })
        })
        if (
          current &&
          !list.some(
            (item) =>
              item && (item.value === current || item.uid === current)
          )
        ) {
          list.unshift({
            value: current,
            label: form.productionTaskCode || current
          })
        }
        return list
      }
      const prevDisabled = field.disabled
      field.disabled = (params) => {
        if (params.pageStatus !== 'add') return true
        const form = params.formValues || {}
        if (form._pendingLoadBlocked || form._lockRelation) return true
        return typeof prevDisabled === 'function'
          ? prevDisabled(params)
          : !!prevDisabled
      }
      field.check = (params) => {
        return params.formValues && params.formValues.productionTaskUid
          ? '查看生产单'
          : ''
      }
      field.placeholder = '请选择同标号待生产队列对应任务单'
    }
  })
  // 编辑运输量：仅待装车且任务仍生产中可改
  fields.forEach((field) => {
    if (field.key !== 'shipmentQuantity' && field.label !== '运输数量') return
    const prevDisabled = field.disabled
    field.disabled = (params) => {
      const form = (params && params.formValues) || {}
      if (params.pageStatus === 'add') {
        return typeof prevDisabled === 'function'
          ? prevDisabled(params)
          : !!prevDisabled
      }
      if (form.shipmentStatus !== '待装车') return true
      if (form._quantityEditable === false) return true
      if (form._quantityEditable === true) return false
      return true
    }
  })
  page.formData.cardTip = (params) => {
    const form = params.formValues || {}
    if (params.pageStatus !== 'add') {
      return '编辑不可修改业务单或任务单；如需修改业务单或任务单，联系生产管理员处置转移或删除重新新增。'
    }
    if (!form.sourceProductionTaskUid) return ''
    const changed =
      form.workUid !== form.sourceWorkUid ||
      form.productionTaskUid !== form.sourceProductionTaskUid
    if (!changed) return ''
    return '你修改了当前浇筑令和任务单，业务车次按新浇筑令自动重排，提交后相当于将本新增的运输单转移给选择的浇筑令，当前生产任务自动暂停，并按照本单前的生产数据重置原任务单的已生产量。'
  }
  page.formData.disabledButtonCodes = (params) => {
    const form = params.formValues || {}
    if (form._pendingLoadBlocked) return ['post', 'buffer']
    return []
  }
})(goodsShipment)

// 运输装车：供方=拌和站只读；车牌仅混凝土运输进场车辆，无车时可去进场
;(function setupMixShipmentSupplierCar(page) {
  const fields = page.formData && page.formData.fields
  if (!fields) return
  const concreteCars = (params) => {
    const list =
      (params.getters &&
        params.getters['officialCar/noExitCar']) ||
      []
    return list
      .filter((item) => item && item.carUsage === '混凝土运输')
      .map((item) => {
        const parts = [item.carCode, item.carName, item.carModel].filter(
          (v) => v != null && String(v).trim() !== ''
        )
        return Object.assign({}, item, {
          value: item.carCode,
          label: parts.join(' / ')
        })
      })
  }
  fields.forEach((field) => {
    if (field.key === 'supplierName' || field.label === '供方名称') {
      field.type = 'input'
      field.disabled = true
      field.placeholder = '由当前生产任务所选拌和站自动带出'
      field.create = false
      field.filterable = false
      delete field.options
      delete field.checkByValue
    }
    if (field.key === 'carCode' || field.label === '运输车牌号') {
      field.options = concreteCars
      field.checkByValue = true
      field.create = false
      field.optionCustom = false
      field.customKey = ''
      field.filterable = true
      field.remote = false
      field.placeholder =
        '请在混凝土运输车辆中搜索选择，如果没有点击去进场车辆按钮办理进场'
      field.check = (params) => {
        return concreteCars(params).length ? '' : '去进场车辆'
      }
    }
    if (field.key === 'shipmentQuantity' || field.label === '运输数量') {
      field.placeholder = (params) => {
        const form = (params && params.formValues) || {}
        if (!form.sourceProductionTaskUid) {
          return '请输入大于0的数值'
        }
        const batch = Number(form.sourceBatchRemain)
        const retarget =
          form.workUid !== form.sourceWorkUid ||
          form.productionTaskUid !== form.sourceProductionTaskUid
        if (!retarget) {
          if (!isNaN(batch)) {
            return '须小于本批剩余可装 ' + batch + 'm³'
          }
        } else {
          const remain = Number(form.targetRemainQuantity)
          const limits = []
          if (!isNaN(batch)) limits.push(batch)
          if (!isNaN(remain)) limits.push(remain)
          if (limits.length) {
            return '须小于 ' + Math.min.apply(null, limits) + 'm³（本批可装与令剩余取小）'
          }
        }
        return '请输入大于0的数值'
      }
    }
  })
})(goodsShipment)

// 拌和站运输装车：存草稿（待装车），不校验车牌/驾驶员/装货时间
;(function setupMixShipmentDraft(page) {
  if (!page.formData) return
  page.formData.bottomButtons = setFormButtons(['取消', '存草稿', '提交'])
  if (!page.formRules) page.formRules = {}
  const draftOptional = (params) => {
    return !(params.formValues && params.formValues.shipmentStatus === '待装车')
  }
  ;['carCode', 'driverName', 'loadTime'].forEach((key) => {
    const rules = page.formRules[key]
    if (!rules || !rules.length) return
    rules.forEach((rule) => {
      if (rule.required === true) {
        rule.required = draftOptional
      }
    })
  })
})(goodsShipment)

const deviceData = Object.assign({}, clone(goodsShipmentPages.deviceData), {
  componentTypes: ['navigate', 'deviceData'],
  getParentFun: 'mixingProduction/getMixingProductionList'
})

const drillDetailPage = [
      {
        buttonName: '浇筑令编号',
        name: 'orderAppliedDetail',
        type: 'drawerTable',
        checkType: 'checkByRow',
        checkFun: 'mixingProduction/getOrderAppliedDetail'
      },
      {
        buttonName: '生产进度(m³)',
        name: 'shipmentList',
        type: 'drawerTable',
        checkType: 'checkByUid',
        checkFun: 'mixingProduction/getMixingProductionInfo'
      }
]

const listColumns = (group) => {
  const columns = [
      {
        prop: 'queueNoText',
        label: '队列',
        width: '50px'
      },
      {
        prop: 'taskCode',
        label: '任务单编号',
        width: '130px',
        overflow: false,
        tooltip: { tipKey: 'taskCode' }
      },
      {
        prop: 'pouringOrderCode',
        label: '浇筑令编号',
        width: '150px',
        drillDown: true,
        overflow: false,
        tooltip: { tipValue: '点击查看浇筑令及申请详情' }
      },
      {
        prop: 'pouringLocation',
        label: '浇筑分项及部位',
        width: '240px',
        overflow: false,
        tooltip: () => {
          return (row) => {
            return {
              tipValue:
                (row.singleProName ? row.singleProName + ' / ' : '') +
                (row.pouringLocation || row.subitemName || '')
            }
          }
        }
      },
      {
        prop: 'strengthGrade',
        label: '强度',
        width: '58px'
      },
      {
        prop: 'appliedQuantity',
        label: '申请(m³)',
        width: '72px'
      },
      {
        prop: 'timeText',
        label: '计划/开始/完成',
        width: '148px',
      className: 'multi-line',
        overflow: false,
        tooltip: () => {
          return (row) => {
            return {
              tipValue:
              '计划 ' +
              (row.displayPlanTime || row.plannedPouringTime || '-') +
              '；开始 ' +
              (row.displayStartTime ||
                row.firstStartTime ||
                row.startTime ||
                '-') +
              '；完成 ' +
              (row.displayFinishTime || row.finishTime || '-')
            }
          }
        }
      },
      {
      prop: 'productionProgress',
      label: '生产进度(m³)',
      width: '200px',
      keepWidth: true,
      drillDown: true,
      overflow: false,
      tooltip: { tipValue: '点击查看运输单，可转移或新增' }
    },
    {
      prop: 'signingOpinionText',
      label: '签收意见',
      width: '220px',
      className: 'multi-line clamp-cell',
      overflow: false,
      overflowWidth: true,
      clampLines: 3,
      tooltip: { tipKey: 'signingOpinionText' }
      },
      {
        prop: 'taskStatusCn',
        label: '状态',
        width: '76px',
        tag: [
          { label: '待生产', type: 'info' },
          { label: '生产中', type: 'success' },
          { label: '生产完成', type: '' },
          { label: '已暂停', type: 'warning' },
          { label: '已中止', type: 'danger' },
        { label: '已中止待处置', type: 'warning' },
        { label: '不合格待处置', type: 'danger' }
      ]
    }
  ]
  if (group !== 'finished') {
    columns.push({
        label: '操作',
        fixed: 'right',
        buttons: setTableButtons([
            { name: '开始', code: 'taskStart' },
            { name: '置顶', code: 'moveTop' },
          { name: '上移', code: 'moveUp' },
            { name: '下移', code: 'moveDown' }
          ])
    })
        }
  return columns
      }

const orderAppliedDetail = {
    name: 'orderAppliedDetail',
    title: (params) => {
      const info = params.state.mixingProduction.orderAppliedDetail || {}
    return '浇筑令详情 - ' + (info.pouringOrderCode || '')
    },
    size: '70%',
    cellAlign: 'center',
    getParentFun: 'mixingProduction/getMixingProductionList',
    detailPage: [],
    tagInfo: (params) => {
      const info = params.state.mixingProduction.orderAppliedDetail || {}
      return (
        '任务：' +
        (info.taskCode || '-') +
        '（' +
        (info.taskStatusCn || '-') +
        '）；部位：' +
        (info.pouringLocation || '-') +
        '；强度：' +
        (info.strengthGrade || '-') +
        '；设计方量：' +
        (info.designQuantity != null ? info.designQuantity : '-') +
        'm³；计划浇筑：' +
        (info.plannedPouringTime || '-')
      )
    },
    rowData: (params) => {
      const info = params.state.mixingProduction.orderAppliedDetail || {}
      return info.appliedList || []
    },
    columns: [
      {
        label: '申请类型',
        prop: 'appliedType',
        tag: [{ label: '补方', type: 'warning' }],
        width: '90px'
      },
      {
        label: '申请时间',
        prop: 'appliedTime',
        width: '160px'
      },
      {
        label: '申请方量(m³)',
        prop: 'appliedQuantity',
        width: '110px'
      },
      {
        label: '申请人',
        prop: 'appliedPerson',
        tooltip: () => {
          return (row) => {
            return { tipValue: row.appliedPhone }
          }
        },
        width: '90px'
      },
      {
        label: '环境温度(℃)',
        prop: 'ambientTemperature',
        width: '110px'
      },
      {
        label: '坍落度(mm)',
        prop: 'slump',
        width: '100px'
      },
      {
        label: '生产要求',
        prop: 'productionRequirements'
      },
      {
        label: '备注',
        prop: 'remarks'
      },
      {
        label: '审核状态',
        prop: 'status',
        tag: [
          { label: '审核拒绝', type: 'danger' },
          { label: '审核通过', type: 'success' },
          { label: '待审核', type: 'warning' }
        ],
        width: '100px'
      }
    ]
}

const shipmentList = {
    name: 'shipmentList',
    title: (params) => {
      const info = params.state.mixingProduction.productionInfo || {}
      return (
        '运输单列表 - ' +
        (info.pouringOrderCode || '') +
        (info.taskCode ? '（任务 ' + info.taskCode + '）' : '')
      )
    },
    size: '70%',
    cellAlign: 'center',
    getParentFun: 'mixingProduction/getMixingProductionList',
  deleteFun: 'goodsShipment/deleteGoodsShipment',
  headButtons: (params) => {
    const info =
      (params.state.mixingProduction &&
        params.state.mixingProduction.productionInfo) ||
      {}
    const produced = Number(info.producedQuantity) || 0
    const shipped =
      info.loadingQuantity != null && info.loadingQuantity !== ''
        ? Number(info.loadingQuantity) || 0
        : (info.shipmentList || []).reduce(
            (sum, item) => sum + (Number(item.shipmentQuantity) || 0),
            0
          )
    const buttons = []
    if (info.taskStatus === '6' && produced > shipped + 0.01) {
      buttons.push({ name: '重置已生产量', code: 'resetProduced' })
    }
    if (shipped + 0.01 < produced) {
      buttons.push({ name: '新增', code: 'addShipment' })
    }
    return buttons.length ? setCheckButtons(buttons) : []
  },
  detailPage: [
    {
      buttonName: '新增',
      code: 'addShipment'
    },
    {
      buttonName: '处置',
      code: 'transferShipment',
      name: 'transferShipmentForm',
      type: 'dialogForm',
      checkType: 'useRowData'
    },
    {
      buttonName: '编辑',
      name: 'goodsShipment',
      type: 'stepForm',
      theme: 'mixingProduction',
      step: 'goodsShipmentInfo',
      label: '编辑运输单信息',
      checkType: 'checkByUid',
      checkFun: 'goodsShipment/getGoodsShipmentInfo'
    },
    {
      buttonName: '监控',
      name: 'deviceData',
      type: 'deviceData',
      label: '查看物联监控数据',
      theme: 'mixingProduction',
      step: 'deviceDataInfo',
      checkType: 'checkByKey',
      checkKey: 'carEnterUid',
      checkFun: 'officialCar/getOfficialCarEnterInfo',
      pageStatus: 'current'
    }
  ],
    rowData: (params) => {
      return (
        (params.state.mixingProduction.productionInfo &&
          params.state.mixingProduction.productionInfo.shipmentList) ||
        []
      )
    },
    columns: [
      {
        label: '业务车次',
        prop: 'trainNumber',
        width: '80px'
      },
      {
        label: '运输单编号',
        prop: 'shipmentNum',
        width: '180px'
      },
      {
        label: '运输车牌号',
        prop: 'carCode'
      },
      {
        label: '驾驶员',
        prop: 'driverName',
        tooltip: () => {
          return (row) => {
            return { tipValue: row.driverPhone }
          }
        }
      },
      {
        label: '供方名称',
        prop: 'supplierName',
        tooltip: () => {
          return (row) => {
            return {
              tipValue:
                (row.supplierResponPerson || '') +
                '\xa0\xa0' +
                (row.supplierResponPhone || '')
            }
          }
        }
      },
      {
        label: '运输方量(m³)',
        prop: 'shipmentQuantity'
      },
      {
        label: '发车时间',
        prop: 'departureTime',
        tooltip: () => {
          return (row) => {
            return {
              tipValue: '装货时间：' + (row.loadTime || '-')
            }
          }
        },
        width: '180px'
      },
      {
        label: '运输状态',
        prop: 'shipmentStatus',
        tag: [
        { label: '待装车', type: 'info' },
          { label: '待发车', type: 'warning' },
          { label: '运输中', type: '' },
          { label: '合格签收', type: 'success' },
        { label: '不合格签收', type: 'danger' },
        { label: '不合格待处置', type: 'warning' },
        { label: '已中止待处置', type: 'warning' }
        ],
        tooltip: () => {
          return (row) => {
            return {
            tipValue:
              (row.signingTime ? row.signingTime + ' ' : '') +
              '签收意见：' +
              (row.signingOpinion || '无')
            }
          }
        }
      },
      {
        label: '签收类型',
        prop: 'signingType',
        tag: [
          { label: '中间签收', type: '' },
          { label: '终车签收', type: 'success' }
        ]
      },
      {
        label: '签收人',
        prop: 'signee'
      },
      {
        label: '签收时间',
        prop: 'signingTime',
        width: '160px'
    },
    {
      label: '操作',
      fixed: 'right',
      width: '460px',
      buttons: setTableButtons([
        { name: '处置', code: 'transferShipment' },
        '编辑',
        '发车',
        '删除',
        '监控',
        '二维码'
      ]),
      overflow: false
    }
  ]
}

const startForm = {
  name: 'startForm',
  title: '开始生产',
  getParentFun: 'mixingProduction/getMixingProductionList',
  formParams: {
    batchQuantity: '',
    taskStatus: '1',
    factoryUid: '',
    carUid: ''
  },
  formRules: {
    factoryUid: [
      {
        required: (params) => {
          const stations =
            (params.state.mixingProduction &&
              params.state.mixingProduction.myMixingStations) ||
            []
          const busy =
            (params.state.mixingProduction &&
              params.state.mixingProduction.busyCarUids) ||
            []
          return stations.some((station) =>
            ((station && station.cars) || []).some(
              (car) => car && car.carUid && busy.indexOf(car.carUid) < 0
            )
          )
        },
        message: '请选择拌和站',
        trigger: 'change'
      }
    ],
    carUid: [
      {
        required: (params) => {
          const stations =
            (params.state.mixingProduction &&
              params.state.mixingProduction.myMixingStations) ||
            []
          const busy =
            (params.state.mixingProduction &&
              params.state.mixingProduction.busyCarUids) ||
            []
          return stations.some((station) =>
            ((station && station.cars) || []).some(
              (car) => car && car.carUid && busy.indexOf(car.carUid) < 0
            )
          )
        },
        message: '请选择拌和设备',
        trigger: 'change'
      }
    ],
    batchQuantity: [
      {
        required: (params) => {
          const stations =
            (params.state.mixingProduction &&
              params.state.mixingProduction.myMixingStations) ||
            []
          const busy =
            (params.state.mixingProduction &&
              params.state.mixingProduction.busyCarUids) ||
            []
          return stations.some((station) =>
            ((station && station.cars) || []).some(
              (car) => car && car.carUid && busy.indexOf(car.carUid) < 0
            )
          )
        },
        message: '请输入本次生产方量',
        trigger: 'blur'
      },
      {
        validator: (params) => {
          const remain = parseFloat(
            params.formValues && params.formValues.remainQuantity != null
              ? params.formValues.remainQuantity
              : 0
          )
          return (rule, value, callback) => {
            const val = parseFloat(value)
            if (value === '' || value === null || value === undefined) {
              callback()
              return
            }
            if (!(val > 0)) {
              callback(new Error('本次生产方量必须大于0'))
              return
            }
            if (val > remain + 0.01) {
              callback(
                new Error(
                  '本次生产方量不可大于剩余可生产 ' +
                    (isNaN(remain) ? 0 : remain) +
                    'm³'
                )
              )
              return
            }
            callback()
          }
        },
        trigger: ['blur', 'change']
      }
    ]
  },
  formData: (params) => {
    const stations =
      (params.state.mixingProduction &&
        params.state.mixingProduction.myMixingStations) ||
      []
    const busy =
      (params.state.mixingProduction &&
        params.state.mixingProduction.busyCarUids) ||
      []
    const form = params.formValues || {}
    const hasFreeCar = stations.some((station) =>
      ((station && station.cars) || []).some(
        (car) => car && car.carUid && busy.indexOf(car.carUid) < 0
      )
    )
    if (!stations.length) {
      return [
        {
          key: 'stationEmptyTip',
          type: 'tag',
          tagType: 'warning',
          tag: '请去添加拌和站并关联相应拌和设备和你的进场信息。',
          span: 24
        }
      ]
    }
    if (!hasFreeCar) {
      return [
        {
          key: 'carBusyTip',
          type: 'tag',
          tagType: 'warning',
          tag: '所有拌和设备均有当前生产任务，请先在当前生产任务管理框中暂停某任务后再开始。',
          span: 24
        }
      ]
    }
    const factoryOpts = stations
      .filter((item) =>
        ((item && item.cars) || []).some(
          (car) => car && car.carUid && busy.indexOf(car.carUid) < 0
        )
      )
      .map((item) => ({
        label: item.name || item.code || item.uid,
        value: item.uid
      }))
    const selected =
      stations.find((item) => item.uid === form.factoryUid) || null
    const carOpts = ((selected && selected.cars) || [])
      .filter((car) => car && car.carUid && busy.indexOf(car.carUid) < 0)
      .map((car) => ({
        label:
          (car.carName || '设备') +
          (car.carCode ? '（' + car.carCode + '）' : ''),
        value: car.carUid
      }))
    return [
      {
        key: 'strengthGrade',
        label: '强度等级',
        type: 'input',
        disabled: true
      },
      {
        key: 'remainQuantity',
        label: '剩余可生产',
        type: 'input',
        disabled: true,
        inputButton: 'm³'
      },
      {
        key: 'ambientTemperature',
        label: '环境温度',
        type: 'input',
        disabled: true,
        placeholder: '无',
        inputButton: '℃'
      },
      {
        key: 'slump',
        label: '坍落度',
        type: 'input',
        disabled: true,
        placeholder: '无',
        inputButton: 'mm'
      },
      {
        key: 'productionRequirements',
        label: '生产要求',
        type: 'input',
        inputType: 'textarea',
        autosize: { minRows: 2, maxRows: 4 },
        disabled: true,
        placeholder: '无',
        span: 12
      },
      {
        key: 'remarks',
        label: '备注',
        type: 'input',
        inputType: 'textarea',
        autosize: { minRows: 2, maxRows: 4 },
        disabled: true,
        placeholder: '无',
        span: 12
      },
      {
        key: 'factoryUid',
        label: '拌和站',
        type: 'select',
        placeholder: factoryOpts.length
          ? '请选择拌和站'
          : '暂无可选拌和站',
        options: factoryOpts,
        checkByValue: true,
        disabled: !factoryOpts.length
      },
      {
        key: 'carUid',
        label: '拌和设备',
        type: 'select',
        placeholder: carOpts.length
          ? '请选择拌和设备'
          : '暂无可用设备',
        options: carOpts,
        checkByValue: true,
        disabled: !carOpts.length
      },
      {
        key: 'batchQuantity',
        label: '本次生产方量',
        type: 'input',
        placeholder: '请输入本次生产方量，须大于0且不超过剩余可生产',
        inputButton: 'm³',
        number: 2,
        span: 24
      },
      {
        key: 'quotaTip',
        type: 'tag',
        tag: '可生产额度 = 申请量 − 合格签收 − 在途占用（待装车/待发车/运输中）；废弃或转移释放在途占用，合格签收才永久减少额度。一台拌和设备同时仅可开启一个当前生产任务。每个生产任务同时仅允许一张待装车运输单。',
        span: 24
      }
    ]
  }
}

const transferShipmentForm = {
  name: 'transferShipmentForm',
  title: '处置运输单',
  formParams: {
    disposeType: '',
    targetOrderUid: '',
    receiveTaskUid: '',
    receiveTaskText: '',
    receiveQuantity: '',
    wasteQuantity: '',
    carCode: '',
    carEnterUid: '',
    driverName: '',
    driverPhone: '',
    shipmentStatus: '',
    _vehicleEditable: false
  },
  formRules: {
    disposeType: [
      {
        required: true,
        message: '请选择处置方式',
        trigger: 'change'
      }
    ],
    targetOrderUid: [
      {
        required: (params) => {
          return (
            params.formValues && params.formValues.disposeType === '转移运输'
          )
        },
        message: '请选择接收浇筑令',
        trigger: 'change'
      }
    ],
    carCode: [
      {
        required: true,
        message: '运输车牌号不能为空',
        trigger: 'change'
      }
    ],
    driverName: [
      {
        required: true,
        message: '驾驶员不能为空',
        trigger: 'change'
      }
    ],
    driverPhone: [
      {
        required: true,
        message: '司机手机号码不能为空',
        trigger: 'change'
      }
    ]
  },
  formData: [
    {
      key: 'shipmentNum',
      label: '运输单编号',
      type: 'input',
      disabled: true
    },
    {
      key: 'carCode',
      label: '运输车牌号',
      type: 'select',
      placeholder: '待装车或车辆为空时请选择挂接车辆',
      filterable: true,
      checkByValue: true,
      options: (params) => {
        const list =
          (params.getters && params.getters['officialCar/noExitCar']) || []
        return list
          .filter((item) => item && item.carUsage === '混凝土运输')
          .map((item) => {
            const parts = [item.carCode, item.carName, item.carModel].filter(
              (v) => v != null && String(v).trim() !== ''
            )
            return Object.assign({}, item, {
              value: item.carCode,
              label: parts.join(' / '),
              carEnterUid: item.uid || item.carEnterUid || item.enterUid || ''
            })
          })
      },
      disabled: (params) => {
        const form = (params && params.formValues) || {}
        return form._vehicleEditable !== true
      }
    },
    {
      key: 'driverName',
      label: '驾驶员',
      type: 'input',
      disabled: (params) => {
        const form = (params && params.formValues) || {}
        return form._vehicleEditable !== true
      }
    },
    {
      key: 'driverPhone',
      label: '司机手机号码',
      type: 'input',
      disabled: (params) => {
        const form = (params && params.formValues) || {}
        return form._vehicleEditable !== true
      }
    },
    {
      key: 'shipmentQuantity',
      label: '运输方量',
      type: 'input',
      disabled: true,
      inputButton: 'm³'
    },
    {
      key: 'disposeType',
      label: '处置方式',
      type: 'select',
      options: [
        { value: '转移运输', label: '转移运输' },
        { value: '废方处置', label: '废方处置' }
      ],
      placeholder: '请选择处置方式',
      checkByValue: true,
      span: 12
    },
    {
      key: 'targetOrderUid',
      label: '接收浇筑令',
      type: 'select',
      placeholder: '请选择同标号浇筑令',
      isShow: (params) => {
        return params.formValues && params.formValues.disposeType === '转移运输'
      },
      options: (params) => {
        const list = params.state.mixingProduction.signTransferTargets || []
        const seen = {}
        const options = []
        list.forEach((item) => {
          if (!item.orderUid || seen[item.orderUid]) return
          seen[item.orderUid] = true
          options.push({
            value: item.orderUid,
            label:
              (item.pouringOrderCode || '-') +
              ' / ' +
              (item.strengthGrade || '-') +
              ' / ' +
              (item.pouringLocation || item.subitemName || '-')
          })
        })
        return options
      },
      checkByValue: true,
      span: 24
    },
    {
      key: 'receiveTaskText',
      label: '接收任务单',
      type: 'input',
      disabled: true,
      placeholder: '选择浇筑令后自动带出',
      isShow: (params) => {
        return params.formValues && params.formValues.disposeType === '转移运输'
      },
      span: 24
    },
    {
      key: 'receiveQuantity',
      label: '接收方量',
      type: 'input',
      disabled: true,
      inputButton: 'm³',
      isShow: (params) => {
        return params.formValues && params.formValues.disposeType === '转移运输'
      }
    },
    {
      key: 'wasteQuantity',
      label: '废方方量',
      type: 'input',
      disabled: true,
      inputButton: 'm³',
      isShow: (params) => {
        return params.formValues && params.formValues.disposeType === '转移运输'
      }
    },
    {
      key: 'transferTip',
      type: 'tag',
      isShow: (params) => {
        return params.formValues && params.formValues.disposeType === '废方处置'
      },
      tag: '废方处置将把本运输单改为不合格签收，签收意见默认为：浇筑令中止，无待生产任务接收。',
      span: 24
    }
  ]
}

const pauseForm = {
  name: 'pauseForm',
  title: '暂停生产',
  getParentFun: 'mixingProduction/getMixingProductionList',
  formParams: {},
  formRules: {},
  formData: (params) => {
    const form = params.formValues || {}
    const pending = Number(form.currentBatchQuantity) || 0
    const fields = [
      {
        key: 'taskCode',
        label: '任务单编号',
        type: 'input',
        disabled: true,
        span: 24
      }
    ]
    if (pending > 0.01) {
      fields.push({
        key: 'pauseTip',
        type: 'tag',
        tagType: 'warning',
        tag:
          '本批次计划 ' +
          (form.batchPlanQuantity || 0) +
          'm³，已装车 ' +
          (form.batchLoadedQuantity || 0) +
          'm³，未装差额 ' +
          pending +
          'm³。确认暂停后将按本批次已装车量重置已生产量。',
        span: 24
      })
    } else {
      fields.push({
        key: 'pauseTip',
        type: 'tag',
        tag: '确认后当前生产任务将暂停，排队顺序不变。',
        span: 24
      })
    }
    return fields
  }
}

const productionEdit = {
    name: 'productionEdit',
    title: '编辑生产任务',
    editFun: 'mixingProduction/editMixingProduction',
    getParentFun: 'mixingProduction/getMixingProductionList',
    formParams: {
      producedQuantity: 0,
      remarks: ''
    },
    formRules: {
      producedQuantity: [
        {
          pattern: /^(0|[1-9]\d*)(\.\d+)?$/g,
          message: '已生产方量应为不小于0的数值',
          trigger: 'blur'
        }
      ]
    },
    formData: [
      {
        key: 'producedQuantity',
        label: '已生产方量',
        type: 'input',
        placeholder: '请输入拌合站当前已产出方量',
        inputButton: 'm³',
        number: 2
      },
      {
        key: 'remarks',
        label: '备注说明',
        type: 'input',
        placeholder: '生产安排或其他说明',
        span: 24
      }
    ]
  }

const listBase = {
  name: 'mixingProduction',
  componentTypes: componentTypes,
  getListFun: 'mixingProduction/getMixingProductionList',
  editFun: 'mixingProduction/editMixingProduction',
  getQcode: 'mixingProduction/getMixingProductionQrcode',
  queryParams: {
    orgUid: (params) => {
      return params.orgValue
    },
    taskStatus: '',
    query: ''
  },
  rowData: (params) => {
    return params.state.mixingProduction.productionList.result
  },
  rowTotal: (params) => {
    return params.state.mixingProduction.productionList.totalSize
  },
  hasPagination: true,
  orderAppliedDetail: orderAppliedDetail,
  shipmentList: shipmentList,
  transferShipmentForm: transferShipmentForm
}

const mixingProduction = {
  pageTabs: [
    {
      label: '待生产任务',
      theme: 'mixingProduction',
      step: 'mixingProductionList',
      stepLabel: '砼拌站生产',
      checkFun: 'mixingProduction/getMixingProductionList'
    },
    {
      label: '已完成/已中止',
      theme: 'mixingProduction',
      step: 'mixingProductionFinishedList',
      stepLabel: '已完成/已中止生产任务',
      checkFun: 'mixingProduction/getMixingProductionList'
    }
  ],
  mixingProduction: Object.assign({}, listBase, {
    queryParams: Object.assign({}, listBase.queryParams, { group: 'active' }),
    headButtons: setCheckButtons([
      { name: '拌合站生产码', code: 'qrcode', icon: 'el-icon-postcard' },
      { name: '自动排序', code: 'autoSort', icon: 'el-icon-sort' },
      { name: '刷新队列' }
    ]),
    selectData: [
      {
        key: 'taskStatus',
        label: '任务状态',
        type: 'select',
        options: [
          { value: '0', label: '待生产' },
          { value: '1', label: '生产中' },
          { value: '3', label: '已暂停' },
          { value: '6', label: '已中止待处置' },
          { value: '7', label: '不合格待处置' }
        ],
        checkByValue: true
      },
      {
        key: 'query',
        label: '关键词',
        type: 'input',
        placeholder: '任务编号/浇筑令编号/浇筑分项/强度等级'
      }
    ],
    columns: listColumns('active'),
    detailPage: drillDetailPage.concat([
      {
        buttonName: '开始',
        name: 'startForm',
        type: 'dialogForm',
        checkType: 'useRowData'
      }
    ]),
    startForm: startForm,
    pauseForm: pauseForm,
    productionEdit: productionEdit
  }),
  mixingProductionFinished: Object.assign({}, listBase, {
    queryParams: Object.assign({}, listBase.queryParams, { group: 'finished' }),
    headButtons: [],
    selectData: [
      {
        key: 'taskStatus',
        label: '任务状态',
        type: 'select',
        options: [
          { value: '2', label: '生产完成' },
          { value: '4', label: '已中止' }
        ],
        checkByValue: true
      },
      {
        key: 'query',
        label: '关键词',
        type: 'input',
        placeholder: '任务编号/浇筑令编号/浇筑分项/强度等级'
      }
    ],
    columns: listColumns('finished'),
    detailPage: drillDetailPage
  }),
  goodsShipment: goodsShipment,
  deviceData: deviceData
}

export default mixingProduction
